import gql from "graphql-tag";

export const MY_HR_GET_MODULE_ROLES = gql`
  query moduleRoles {
    moduleRoles {
      module
      roles
    }
  }
`;
